import { usePageInfo } from 'app/frontend/base/config/queries'

interface Props {
  character?: wowaudit.Character
}

const GearSummary = ({ character }: Props) => {
  const {
    data: { gameVersion },
  } = usePageInfo()
  if (!character?.details || !character?.refreshedAt) return null

  const liStyles = 'bg-card-nested border my-1 py-1 px-2 rounded-md'
  const { details } = character

  const enchantsMissing = details.gearStatus.enchants_missing ?? 0
  const enchantsNotBis = details.gearStatus.enchants_not_bis ?? 0
  const emptySockets = details.gearStatus.empty_sockets ?? 0
  const poorQualityGems = details.gearStatus.poor_quality_gems ?? 0
  const tierItems = details.tierItemsEquipped ?? 0
  const embellishments = details.gearStatus.embellishments ?? 0

  return (
    <ul>
      <li className='bg-card-nested border my-1 py-3 px-4 rounded-md flex items-center gap-4'>
        <span className='text-2xl font-medium leading-none tracking-tight'>
          {details.currentItemLevel}
        </span>
        <span className='flex flex-col leading-tight'>
          <span>item level</span>
          {(details.maxItemLevel ?? 0) > (details.currentItemLevel ?? 0) && (
            <span className='text-sm text-muted-foreground'>
              max{' '}
              <strong className='text-foreground'>
                {details.maxItemLevel}
              </strong>
            </span>
          )}
        </span>
      </li>

      <li className={liStyles}>
        <strong
          className={
            enchantsMissing > 0
              ? 'text-destructive-foreground'
              : 'text-success-foreground'
          }
        >
          {enchantsMissing}
        </strong>{' '}
        enchant{enchantsMissing === 1 ? '' : 's'} missing
      </li>

      {gameVersion !== 'classic_era' ? (
        <li className={liStyles}>
          <strong
            className={
              enchantsNotBis > 0
                ? 'text-warning-foreground'
                : 'text-success-foreground'
            }
          >
            {enchantsNotBis}
          </strong>{' '}
          poor quality enchant{enchantsNotBis === 1 ? '' : 's'}
        </li>
      ) : null}

      {gameVersion !== 'classic_era' ? (
        <li className={liStyles}>
          <strong
            className={
              poorQualityGems > 0
                ? 'text-warning-foreground'
                : 'text-success-foreground'
            }
          >
            {poorQualityGems}
          </strong>{' '}
          poor quality gem{poorQualityGems === 1 ? '' : 's'}
        </li>
      ) : null}

      {gameVersion !== 'classic_era' ? (
        <li className={liStyles}>
          <strong
            className={
              emptySockets !== 0
                ? 'text-destructive-foreground'
                : 'text-success-foreground'
            }
          >
            {emptySockets}
          </strong>{' '}
          empty socket{emptySockets === 1 ? '' : 's'}
        </li>
      ) : null}

      <li className={liStyles}>
        <strong
          className={
            tierItems >= (gameVersion === 'classic_era' ? 8 : 5)
              ? 'text-success-foreground'
              : 'text-warning-foreground'
          }
        >
          {tierItems} / {gameVersion === 'classic_era' ? 9 : 5}
        </strong>{' '}
        tier items obtained
      </li>

      {gameVersion === 'live' ? (
        <li className={liStyles}>
          <strong
            className={
              embellishments === 2
                ? 'text-success-foreground'
                : 'text-destructive-foreground'
            }
          >
            {embellishments}
          </strong>{' '}
          embellishment{embellishments === 1 ? '' : 's'} equipped
        </li>
      ) : null}
    </ul>
  )
}

export default GearSummary
